module.exports = __webpack_public_path__ + "assets/img/voice-mute.90fa77e0.png";